import { FileField, FileInput, useTranslate } from "react-admin";
import React, { Fragment } from "react";

import { FormHelperText } from "@material-ui/core";
import { MAX_FILE_SIZE } from "../../config";
import { get } from "lodash";

const FileFieldWrapper = (props) => {
  const { source, record } = props;
  const url = get(record, source);
  return <FileField {...props} source="url" record={{ ...record, url }} />;
};

const SignedDocMediaInput = (props) => {
  const { resource, source } = props;
  const translate = useTranslate();

  return (
    <Fragment>
      <FileInput {...props} maxSize={MAX_FILE_SIZE} accept={".pdf"}>
        <FileFieldWrapper source="file.path" title="file.name" />
      </FileInput>
      <FormHelperText>
        {translate(`resources.${resource}.fields.${source}.help`, {
          accepted: ".pdf",
        })}
      </FormHelperText>
    </Fragment>
  );
};
export default SignedDocMediaInput;
